module.exports = __webpack_public_path__ + "static/media/footer.643d1b73.png";